import React, { FunctionComponent } from "react";
import styles from "../styles/AnalysisDashboard.css";
import Body from "./Body";

interface Props {}

const AnalysisDashboard: FunctionComponent<Props> = () => {

    return (
        <div className={styles.bodyContainer} >
            <Body />
        </div>
    )
}

export default AnalysisDashboard;